const categoryOptions = ['Web Browser', 'PC (Windows)'];

export default categoryOptions;
